/* Skko theme — vanilla JS, no dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const S = window.Skko || { routes: {}, strings: {} };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.documentElement.classList.add('has-drawer');
    $$(`[data-drawer-open="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('button, a, input', drawer.querySelector('.drawer__panel'));
    focusable && focusable.focus({ preventScroll: true });
  }
  function closeDrawer(drawer) {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    $$(`[data-drawer-open="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => {
      drawer.hidden = true;
      if (!$('[data-drawer].is-open')) document.documentElement.classList.remove('has-drawer');
    }, 400);
    lastFocus && lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('[data-drawer]')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('[data-drawer].is-open').forEach(closeDrawer);
  });

  /* ---------- Header ---------- */
  const headerSection = $('.section-header');
  const header = $('[data-header]');
  if (header && headerSection) {
    const transparent = header.classList.contains('header--transparent');
    const mode = (header.className.match(/header--sticky-(\S+)/) || [])[1];
    let lastY = window.scrollY;
    const setOffset = () => {
      document.documentElement.style.setProperty('--header-h', `${header.offsetHeight}px`);
      const visible = mode !== 'none' && !headerSection.classList.contains('is-hidden');
      document.documentElement.style.setProperty('--header-offset', visible ? `${header.offsetHeight}px` : '0px');
    };
    const onScroll = () => {
      const y = window.scrollY;
      if (transparent) {
        const first = document.querySelector('#main > .shopify-section:first-child');
        const limit = first ? Math.max(10, first.offsetHeight - header.offsetHeight - 10) : 10;
        header.classList.toggle('is-solid', y > limit || header.matches(':hover') || !$('#header-search')?.hidden);
      }
      if (mode === 'float') {
        const first = document.querySelector('#main > .shopify-section:first-child');
        const limit = transparent && first ? Math.max(10, first.offsetHeight - header.offsetHeight - 10) : 10;
        header.classList.toggle('is-floating', y > limit);
      }
      if (mode === 'scroll-up') {
        const hide = y > lastY && y > header.offsetHeight + 40 && !$('[data-drawer].is-open');
        headerSection.classList.toggle('is-hidden', hide);
      }
      lastY = y;
      setOffset();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setOffset);
    if (transparent) {
      header.addEventListener('mouseenter', () => header.classList.add('is-solid'));
      header.addEventListener('mouseleave', onScroll);
      header.addEventListener('focusin', () => header.classList.add('is-solid'));
    }
    onScroll();
  }

  /* Search toggle */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    const panel = $('#header-search');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    $$('[data-search-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(!panel.hidden)));
    if (!panel.hidden) { header && header.classList.add('is-solid'); $('input[type="search"]', panel).focus(); }
  });

  /* Announcement rotation */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, (Number(bar.dataset.speed) || 5) * 1000);
  });

  /* ---------- Cart ---------- */
  const fmt = (cents) => {
    try {
      const whole = S.noDecimals && cents % 100 === 0;
      return new Intl.NumberFormat(document.documentElement.lang || 'hr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(2); }
  };

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-num]').forEach((el) => { el.textContent = count; });
  }

  function renderSections(sections) {
    if (!sections) return;
    const html = sections['cart-drawer'];
    const drawer = $('[data-cart-drawer]');
    if (html && drawer) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer]', doc);
      if (fresh) drawer.querySelector('.drawer__panel').replaceWith(fresh.querySelector('.drawer__panel'));
    }
    const pageHtml = sections['main-cart'];
    const page = $('[data-cart-page]');
    if (pageHtml && page) {
      const doc = new DOMParser().parseFromString(pageHtml, 'text/html');
      const fresh = $('[data-cart-page]', doc);
      if (fresh) page.replaceWith(fresh);
    }
  }

  function cartSectionIds() {
    const ids = [];
    if ($('[data-cart-drawer]')) ids.push('cart-drawer');
    const page = $('[data-cart-page]');
    if (page) {
      const sec = page.closest('[id^="shopify-section-"]');
      if (sec) ids.push(sec.id.replace('shopify-section-', ''));
    }
    return ids;
  }

  async function changeQty(key, quantity) {
    const busy = $('[data-cart-drawer]') || $('[data-cart-page]');
    busy && busy.classList.add('is-loading');
    const ids = cartSectionIds();
    try {
      const res = await fetch(`${S.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ids, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.sections) {
        const mapped = {};
        Object.entries(data.sections).forEach(([k, v]) => { mapped[k === 'cart-drawer' ? k : 'main-cart'] = v; });
        renderSections(mapped);
      }
      updateCount(data.item_count || 0);
    } finally {
      const b = $('[data-cart-drawer]') || $('[data-cart-page]');
      b && b.classList.remove('is-loading');
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    changeQty(btn.dataset.qtyChange, Number(btn.dataset.qty));
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cart-open]');
    if (!link || S.cartType !== 'drawer' || !$('#cart-drawer')) return;
    e.preventDefault();
    openDrawer('cart-drawer');
  });

  /* ---------- Product ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = $('[data-product-json]', root);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const addLabel = $('[data-add-label]', root);
    const btnPrice = $('[data-button-price]', root);
    const priceRegular = $('[data-price-regular]', root);
    const priceCompare = $('[data-price-compare]', root);
    const errorEl = $('[data-form-error]', root);
    const media = $('[data-product-media]', root);
    const dots = $$('.product__dot', root);

    const selectedOptions = () => $$('.variant-picker__option', root).map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    function onVariantChange() {
      const opts = selectedOptions();
      $$('.variant-picker__option', root).forEach((fs, i) => {
        const label = $('[data-selected-value]', fs);
        if (label) label.textContent = opts[i] || '';
      });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addLabel.textContent = S.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? S.strings.addToCart : S.strings.soldOut;
      }
      if (btnPrice) btnPrice.textContent = fmt(variant.price);
      if (priceRegular) priceRegular.textContent = fmt(variant.price);
      if (priceCompare) {
        priceCompare.hidden = !(variant.compare_at_price > variant.price);
        if (variant.compare_at_price) priceCompare.textContent = fmt(variant.compare_at_price);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      if (variant.featured_media && media) {
        const item = $(`[data-media-id="${variant.featured_media.id}"]`, media);
        if (item) {
          if (media.scrollWidth > media.clientWidth) media.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
          else if (getComputedStyle(media).position !== 'sticky') item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('.variant-picker')) onVariantChange(); });

    if (media && dots.length) {
      media.addEventListener('scroll', () => {
        const i = Math.round(media.scrollLeft / media.clientWidth);
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      }, { passive: true });
    }

    if (form) {
      form.addEventListener('submit', async (e) => {
        if (S.cartType !== 'drawer' || !$('#cart-drawer')) return;
        e.preventDefault();
        errorEl && (errorEl.hidden = true);
        addBtn.disabled = true;
        const prev = addLabel.textContent;
        addLabel.textContent = S.strings.adding;
        try {
          const fd = new FormData(form);
          fd.append('sections', 'cart-drawer');
          fd.append('sections_url', window.location.pathname);
          const res = await fetch(`${S.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || S.strings.error);
          renderSections(data.sections);
          const cart = await (await fetch(`${S.routes.cart}.js`)).json();
          updateCount(cart.item_count);
          openDrawer('cart-drawer');
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        } finally {
          addBtn.disabled = false;
          addLabel.textContent = prev;
        }
      });
    }
  });

  /* ---------- Quick add (cards, runway looks) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = S.strings.adding; }
    try {
      const fd = new FormData(form);
      const useDrawer = S.cartType === 'drawer' && $('#cart-drawer');
      if (useDrawer) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
      const res = await fetch(`${S.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || S.strings.error);
      if (!useDrawer) { window.location.href = S.routes.cart; return; }
      renderSections(data.sections);
      const cart = await (await fetch(`${S.routes.cart}.js`)).json();
      updateCount(cart.item_count);
      if (btn) btn.textContent = S.strings.added;
      openDrawer('cart-drawer');
      setTimeout(() => { if (btn) btn.textContent = label; }, 1800);
    } catch (err) {
      if (btn) btn.textContent = err.message;
      setTimeout(() => { if (btn) btn.textContent = label; }, 2500);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Scroll reveal ---------- */
  const revealIO = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const watchReveal = (root = document) => $$('[data-reveal]:not(.is-in)', root).forEach((el) => (revealIO ? revealIO.observe(el) : el.classList.add('is-in')));
  watchReveal();
  window.SkkoReveal = watchReveal;

  /* ---------- Gentle parallax for gallery works ---------- */
  const para = $$('[data-parallax]').filter((el) => parseFloat(el.dataset.parallax) > 0);
  if (para.length && !matchMedia('(prefers-reduced-motion: reduce)').matches && matchMedia('(min-width: 750px)').matches) {
    let pt = 0;
    const paint = () => {
      pt = 0;
      const vh = innerHeight;
      para.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const off = (r.top + r.height / 2 - vh / 2) * -parseFloat(el.dataset.parallax);
        el.style.setProperty('--py', `${off.toFixed(1)}px`);
      });
    };
    addEventListener('scroll', () => { if (!pt) pt = requestAnimationFrame(paint); }, { passive: true });
    paint();
  }

  /* ---------- Collection: density + load more ---------- */
  const grid = $('[data-grid]');
  const collection = $('[data-collection]');
  if (collection) {
    const KEY = 'skko-density';
    const apply = (n) => {
      collection.style.setProperty('--cols', n);
      $$('[data-density]').forEach((b) => b.classList.toggle('is-active', b.dataset.density === String(n)));
    };
    try { const saved = localStorage.getItem(KEY); if (saved && $(`[data-density="${saved}"]`)) apply(saved); } catch (_) {}
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-density]');
      if (!b) return;
      apply(b.dataset.density);
      try { localStorage.setItem(KEY, b.dataset.density); } catch (_) {}
    });
  }
  document.addEventListener('click', async (e) => {
    const more = e.target.closest('[data-load-more]');
    if (!more || !grid) return;
    e.preventDefault();
    more.classList.add('is-loading');
    const html = await (await fetch(more.href)).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextGrid = $('[data-grid]', doc);
    if (nextGrid) $$(':scope > *', nextGrid).forEach((el) => grid.appendChild(el));
    watchReveal(grid);
    const nextMore = $('[data-load-more]', doc);
    if (nextMore) { more.href = nextMore.href; more.classList.remove('is-loading'); }
    else more.closest('.collection__more').remove();
    window.history.replaceState({}, '', more.href);
  });

  /* ---------- Carousels ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    const track = $('[data-carousel]', btn.closest('section'));
    if (!track) return;
    const dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * (track.clientWidth + 6), behavior: 'smooth' });
  });
  $$('[data-carousel]').forEach((track) => {
    const count = $('[data-carousel-count]', track.closest('section'));
    if (!count) return;
    const upd = () => {
      const pages = Math.max(1, Math.round(track.scrollWidth / track.clientWidth));
      const cur = Math.min(pages, Math.round(track.scrollLeft / track.clientWidth) + 1);
      count.textContent = `${cur} / ${pages}`;
    };
    track.addEventListener('scroll', upd, { passive: true });
    addEventListener('resize', upd);
    upd();
  });

  $$('[data-slider]').forEach((slider) => {
    const track = $('[data-slider-track]', slider);
    const dots = $$('.slider-dots__dot', slider);
    if (!track || dots.length < 2) return;
    const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
    }, { passive: true });
    if (slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let paused = false;
      slider.addEventListener('mouseenter', () => { paused = true; });
      slider.addEventListener('mouseleave', () => { paused = false; });
      setInterval(() => {
        if (paused || document.hidden) return;
        const i = Math.round(track.scrollLeft / track.clientWidth);
        go((i + 1) % dots.length);
      }, 5000);
    }
  });

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    const html = await (await fetch(el.dataset.url)).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-recommendations]', doc);
    if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; if (window.SkkoReveal) window.SkkoReveal(el); }
  });

  /* ---------- Booking form prefill (?model=) ---------- */
  const model = new URLSearchParams(window.location.search).get('model');
  if (model) $$('[data-prefill-param="model"]').forEach((input) => { if (!input.value) input.value = model; });
})();

/* Noir pieces — swipe counter, progress hairline and arrows */
(() => {
  const init = (track) => {
    if (track.dataset.ready) return;
    track.dataset.ready = '1';
    const ui = track.parentElement.querySelector('.nx-swipe-ui');
    if (!ui) return;
    const count = ui.querySelector('[data-nx-count]'), bar = ui.querySelector('[data-nx-bar]'),
      prev = ui.querySelector('[data-nx-prev]'), next = ui.querySelector('[data-nx-next]');
    const step = () => (track.children[0] ? track.children[0].getBoundingClientRect().width : track.clientWidth);
    const update = () => {
      const w = step(); if (!w) return;
      const pages = Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / w) + 1);
      const i = Math.min(pages - 1, Math.round(track.scrollLeft / w));
      count.textContent = `${i + 1} / ${pages}`;
      bar.style.width = `${100 / pages}%`; bar.style.left = `${(i * 100) / pages}%`;
      prev.disabled = i === 0; next.disabled = i >= pages - 1;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  };
  const boot = () => document.querySelectorAll('[data-nx-swipe]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
